import { render, staticRenderFns } from "./CodeViewer.vue?vue&type=template&id=0060da84&"
import script from "./CodeViewer.vue?vue&type=script&lang=js&"
export * from "./CodeViewer.vue?vue&type=script&lang=js&"
import style0 from "./CodeViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VContainer})
